/**
 * Matcher for Dynamic Customer Profiles.
 * @module
 */

exports.fieldsNeeded = ['dcpData'];

exports.match = function(value, cond) {
  var dcpData = value.dcpData || {};
  var rulesResults = dcpData.conditionValuesResults || {};
  return !!rulesResults[cond.value];
};
